import useAPI from '@/pages/members/hooks/useAPI';
import { SubstanceParams, SubstanceRepository } from '@/repositories/members/SubstanceRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useSubstances = ({ drug_category }: SubstanceParams = {}) => {
  const substanceRepository = SubstanceRepository();

  return useAPI({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'substances', drug_category],
    queryFn: () => substanceRepository.list({ drug_category }),
    refetchOnWindowFocus: false
  });
};
